// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"fae1ef48","458":"9d9989f0","506":"8444a2d7","919":"56d0760b"}[chunkId] + ".chunk.js";
};